module.exports = __webpack_public_path__ + "img/partners7.401147df.jpg";